// Complete large vendor directories beyond Liquid's loop limit. Existing
// server-rendered links retain their dedicated collection destinations.
for (const config of document.querySelectorAll('[data-brand-directory-config]')) {
  const grid = config.previousElementSibling;
  if (!grid?.matches('[data-brand-directory]')) continue;
  const { brands, vendorUrl } = JSON.parse(config.textContent);
  const rendered = new Set(Array.from(grid.querySelectorAll('.collection-directory__title'), (node) => node.textContent));
  for (const brand of brands) {
    if (rendered.has(brand)) continue;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.className = 'collection-directory__link';
    link.href = `${vendorUrl}?q=${encodeURIComponent(brand)}`;
    const details = document.createElement('span');
    details.className = 'collection-directory__details';
    const title = document.createElement('span');
    title.className = 'collection-directory__title';
    title.textContent = brand;
    const caption = document.createElement('span');
    caption.className = 'collection-directory__count';
    caption.textContent = 'Shop collection';
    const arrow = document.createElement('span');
    arrow.className = 'collection-directory__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '↗';
    details.append(title, caption);
    link.append(details, arrow);
    item.append(link);
    grid.append(item);
  }
}
